import { ButtonTitle } from "features/shared/styles/typography/ButtonTitle.styled";
import styled from "styled-components";

const EditButton = styled.button`
  display: flex;
  align-items: center;
  border: none;
  padding: 0;
  background-color: transparent;
  cursor: pointer;

  img {
    margin: 0 4px;
  }

  ${ButtonTitle} {
    color: ${({ theme }) => theme.colors.primary2};
  }
`;

export default EditButton;
